import { FC, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";

import logo from "../../assets/images/sidebarLogo.svg";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomButton from "../customButton/customButton";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/features/toast/toastSlice";
// import logoSmall from "../../assets/images/logoSmall.svg";
// import Constant from "../../util/constant";
// import ConfirmationModal from "../confirmationModal/confirmationModal";

interface SidebarContentProps extends WithTranslation {
  type: string;
  toggleMenuCallback: () => void;
}

const SidebarContent: FC<SidebarContentProps> = ({ t, type, toggleMenuCallback }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubMenuOpen, setSubMenuOpen] = useState<boolean>(false);

  console.log('isSubMenuOpen', isSubMenuOpen);
  
  const [modal, setModal] = useState(false);
  const cancelModal = () => {
    setModal(false);
  };
  const onRemoveTrail = () => {
    setModal(true);
  };
  const onRemoveModal = () => {
      setLoading(true);
      setTimeout(() => {
        localStorage.clear();

        dispatch(
          showToast({
            show: false,
            message: "You have been logged out successfully.",
            type: "success",
          })
        );
        setLoading(false);
        setModal(false);
        navigate(`/login`);
      }, 2000); // 2 seconds delay
    };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const toggleSubMenu = () => {
  //   setSubMenuOpen(!isSubMenuOpen);
  // };

  // const ismodalOpen = () => {
  //   setModal(true)
  // }
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setInterval(() => {
      setLoading(false)
    }, 3000);
  }, []);
  const handleClick = () => {
    toggleMenuCallback()
  };

  return (
    <>
      <div id="sidebar-menu">
        <div className={loading ? "navbar-brand-box placeholder-glow" : "navbar-brand-box"}>
        {loading ? <span className='placeholder w-100'></span> : 
          <Link to="#" className="logo logo-dark">
            <span className= "logo-lg">
              <img src={logo} alt="" />
            </span>
          </Link>
        }
        </div>
        <ul className={loading ? "metis-menu list-unstyled placeholder-glow" : "metis-menu list-unstyled"} id="side-menu">
          <>
            <li className="mm-active">
              <NavLink
                to="/trails"
                className={({ isActive }) => (isActive ? "active" : "inactive")}
                onClick={handleClick}
              >
                <div className="left-menu">
                  <span className={loading ? "icon  icon-Trails-Fill placeholder me-2" : "icon  icon-Trails-Fill"}></span>
                  <span className={loading ? "subTitle w-100 placeholder" :"subTitle"}>{t("TRAILS")}</span>
                </div>
              </NavLink>
            </li>
            <li className="mm-active">
              <NavLink
                to="/add-trail"
                className={({ isActive }) => (isActive ? "active" : "inactive")}
                onClick={handleClick}
              >
                <div className="left-menu">
                  <span className={loading ? "icon icon-plus-square-fill placeholder me-2" : "icon icon-plus-square-fill"}></span>
                  <span className={loading ? "subTitle placeholder" : "subTitle"}>{t("ADD_TRAIL")}</span>
                </div>
              </NavLink>
            </li>
            <li className="mm-active">
              <NavLink
                to="/suggested-trails"
                className={({ isActive }) => (isActive ? "active" : "inactive")}
                onClick={handleClick}
              >
                <div className="left-menu">
                  <span className={loading ? "icon icon-geo placeholder me-2" : "icon icon-geo"}></span>
                  <span className={loading ? "subTitle placeholder" : "subTitle"}>{t("SUGGESTED_TRAIL")}</span>
                </div>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/change-password"
                className={({ isActive }) => (isActive ? "active" : "inactive")}
                onClick={handleClick}
              >
                <div className="left-menu">
                  <span className={loading ? "icon icon-key placeholder me-2" : "icon icon-key"}></span>
                  <span className={loading ? "subTitle placeholder" : "subTitle"}>{t("CHANGE_PASSWORD")}</span>
                </div>
              </NavLink>
            </li>
            <li>
              <button
                type="button"
                className={'logout'}
                onClick={onRemoveTrail}
              >
                <span className={loading ? "icon icon-box-arrow-right placeholder" : "icon icon-box-arrow-right"}></span>
                <span className={loading ? "subTitle placeholder" :"subTitle"}>{t("LOG_OUT")}</span>
              </button>
            </li>
          </>
        </ul>
      </div>

      <Modal isOpen={modal} toggle={cancelModal} className="mainModal" centered>
        <ModalHeader toggle={cancelModal}>
          {t("LOGOUT")}
        </ModalHeader>
        <ModalBody>
          {t("ARE_YOU_SURE_YOU_WISH_TO_LOGOUT")}
        </ModalBody>
        <ModalFooter>
          <CustomButton
            type="button"
            loading={loading} 
            className="btn btn-danger text-white"
            onClick={onRemoveModal}
            title={t("YES_LOGOUT")}
          />
          <CustomButton
            type="button"
            className="btn btn-transparent"
            onClick={cancelModal}
            title={t("NO_CANCEL")}
          />
        </ModalFooter>
      </Modal>
    </>
  );
};

SidebarContent.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(SidebarContent);

